import { clearSessionCookies } from '../helpers/cookie-session-helper';

import { warn } from '../helpers/common';
import { ApiPlugin } from './api-plugins';


/**
 * Authentication error plugin
 */
class AuthenticationPlugin extends ApiPlugin {
  static after(res, config, error) {
    if (!(error && error.response && error.response.status === 401)) {
      return;
    }

    // send to login on a 401 error
    warn('caught 401 unauthorized; sending to login');
    // Clearing the session cookies. on reload it will land on the login screen.
    clearSessionCookies();
    window.location.reload();
    // axios.post('/logout').then(() => {
    //   localforage.createInstance({ driver: localforage.INDEXEDDB, name: 'masterData' }).clear();
    //   setTimeout(() => {
    //     window.location = '/#/login';
    //   }, 50);
    // });

  }
}

export default AuthenticationPlugin;
